<template>
  <div class="voucher">
    <div class="bind-form">
      <md-field>
        <div class="form-group">
          <div class="form-label">
            {{ $t('fortuneCode') }}
          </div>
          <md-input-item
            class="bordered"
            ref="fortuneCode"
            name="fortuneCode"
            type="text"
            v-model="fortuneForm.fortuneCode"
            v-validate="'required'"
            :error="errors.first('fortuneCode')"
          >
            <md-button
              slot="right"
              type="primary"
              @click="redeemCode"
            >
              {{ $t('submit') }}
            </md-button>
          </md-input-item>
        </div>
      </md-field>
    </div>
    <div class="ticket-container">
      <div class="no-data" v-if="!codeList.VALID.length && !codeList.INVALID.length">{{ $t('noData') }}</div>
      <div v-for="(code, index) in codeList.VALID" :key="index" :value="code" class="valid ticket">
        <span class="code-title">
          {{ $t('fortuneCode') }}
        </span>
        <span class="code-number">{{ code.fortuneCode }}</span>
        <div class="code-info">
          <div class="code-desc">
            {{ $t('codeDesc',
            {
            productName: code.productName ? code.productName[$i18n.locale] : '',
            minimum: `'Rp' ${code.minimum.toLocaleString('id')}`,
            },
            ) }}
          </div>
          <div class="code-date">
            {{ moment(code.createTimestamp).format('YYYY.MM.DD') }} -
            {{ moment(code.expireTimestamp).format('YYYY.MM.DD') }}
          </div>
        </div>
      </div>
      <div v-for="(code, i) in codeList.INVALID" :key="`invalid-${i}`" :value="code" class="ticket invalid">
        <span class="code-title">
          {{ $t('fortuneCode') }}
        </span>
        <span class="code-number">{{ code.fortuneCode }}</span>
        <div class="code-info">
          <div class="code-desc">
            {{ $t('codeDesc',
            {
            productName: code.productName ? code.productName[$i18n.locale]: '',
            minimum: `'Rp' ${code.minimum.toLocaleString('id')}`,
            },
            ) }}
          </div>
          <div class="code-date">
            {{ moment(code.createTimestamp).format('YYYY.MM.DD') }} -
            {{ moment(code.expireTimestamp).format('YYYY.MM.DD') }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Field, InputItem, Button } from 'mand-mobile'

export default {
  i18n: {
    messages: {
      en: {
        codeDesc: 'Only limited to {productName},  investment amount should be ≥ {minimum}',
        fortuneCode: 'Voucher',
        submit: 'Add',
        noData: 'No Data',
      },
      id: {
        codeDesc: 'Hanya terbatas pada {productName}, jumlah pendanaan harus ≥ {minimum}',
        fortuneCode: 'Voucher',
        submit: 'Tambahkan ke',
        noData: 'No Data',
      },
    },
  },
  components: {
    [Field.name]: Field,
    [InputItem.name]: InputItem,
    [Button.name]: Button,
  },
  data() {
    return {
      titles: ['Coupon', 'Voucher'],
      defaultIndex: 0,
      codeList: { VALID: {}, INVALID: {} },
      fortuneForm: {
        fortuneCode: '',
      },
      isTrial: false,
    }
  },
  computed: {
    locale() {
      return this.$store.state.locale
    },
  },
  mounted() {
    this.reloadCodeList()
  },
  methods: {
    async reloadCodeList() {
      try {
        const response = await this.$http.get('/voucher/fortune-code/all')
        const data = response.data.data
        if (Object.keys(data).length) {
          if ('VALID' in data) {
            this.codeList.VALID = data.VALID.map(code => {
              return {
                createTimestamp: code.createTimestamp,
                expireTimestamp: code.expireTimestamp,
                fortuneCode: code.fortuneCode,
                minimum: code.limitMinAmount || 0,
                productName: code.investmentName[this.locale],
              }
            })
          } else {
            this.codeList.VALID = []
          }
          if ('INVALID' in data) {
            this.codeList.INVALID = data.INVALID.map(code => {
              return {
                createTimestamp: code.createTimestamp,
                expireTimestamp: code.expireTimestamp,
                fortuneCode: code.fortuneCode,
                minimum: code.limitMinAmount || 0,
                productName: code.investmentName[this.locale],
              }
            })
          } else {
            this.codeList.INVALID = []
          }
        }
      } catch (e) {
        console.error(e)
      }
    },
    async redeemCode() {
      try {
        const result = await this.$validator.validateAll()
        if (result) {
          const payload = {
            fortuneCode: this.fortuneForm.fortuneCode.trim(),
          }
          await this.$http.post('/voucher/fortune-code/bind', payload)
          this.$toast.succeed(this.$t('REDEEM_SUCCESSFUL'))
          await this.reloadCodeList()
          await Promise.all([
            this.$store.dispatch('reloadInvestor', { force: true }),
            this.$store.dispatch('reloadInvestments'),
          ])
        }
      } catch (error) {
        console.error(error)
      }
    },
  },
}
</script>

<style lang="stylus" scoped>
.voucher /deep/ {
  .bind-form {
    padding: 20px;
    background-color: #fff;
  }
  .form-group {
    margin-bottom: 20px;
    .form-label {
      margin-bottom: 8px;
      color: #555;
      font-size: 12px;
    }
  }
  .md-input-item-right {
    height: 36px !important;
  }
}

.ticket-container {
  margin-top: 30px;
  padding: 0 10px;
}

.ticket {
  position: relative;
  display: inline-block;
  width: 300px;
  height: 91px;
  margin: 0 20px 20px 0;
  background-size: contain;
  background-repeat: no-repeat;
}

.valid {
  background-image: url('../../../assets/image/user/ticket/bg-voucher-kp.png');
}

.invalid {
  background-image: url('../../../assets/image/user/ticket/bg-voucher-u.png');
}

.code-title {
  writing-mode: vertical-lr;
  position: absolute;
  top: 18px;
  left: 22px;
  font-size: 14px;
  color: #ffffff;
}

.title-space {
  letter-spacing: 5px;
}

.code-number {
  position: absolute;
  top: 12px;
  left: 80px;
  font-size: 21px;
  color: #ffffff;
}

.code-info {
  position: absolute;
  bottom: 5px;
  left: 80px;
  font-size: 10px;
  right: 15px;
  opacity: 0.8;
  color: #ffffff;
}

.code-desc {
  opacity: 0.8;
  color: #ffffff;
  top: 55px;
  left: 80px;
  font-size: 10px;
}

.code-date {
  margin-top: 5px;
  opacity: 0.8;
  color: #ffffff;
  top: 70px;
  left: 80px;
  font-size: 10px;
}
</style>
